module.exports = __webpack_public_path__ + "static/media/kpibarLogo.438d4ff7.png";